import Vue from 'vue';
import Icon from './Icon.vue';

Vue.component('e-icon', Icon);
